// extracted by mini-css-extract-plugin
export default {"header":"sAwAmzIlLEAYT2ooNLgA","empty":"ZH8ju7wO5kNcYfa46ziB","text":"QS9GDnxpKuMaWYZiGdda","title":"MwfqXai4_EzO6vFlSyOc"};